import UniformConfigurationSelector from './UniformConfigurationSelector';

export default UniformConfigurationSelector;
